
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subjects/[subject]",
      function () {
        return require("private-next-pages/subjects/[subject].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subjects/[subject]"])
      });
    }
  